((global) => {
  function parseVariants(node) {
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); }
    catch (_error) { return []; }
  }

  function findVariant(variants, id) {
    return variants.find((variant) => String(variant.id) === String(id));
  }

  function formatMoney(cents, currency, locale = 'en-US', NumberFormat = Intl.NumberFormat) {
    try {
      if (!/^[A-Z]{3}$/.test(currency || '')) throw new RangeError('Invalid ISO currency');
      return new NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
    } catch (_error) {
      return new NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
    }
  }

  function apply(root, variant, formatMoney) {
    if (!root || !variant) return false;
    const priceContainer = root.querySelector('[data-product-price]');
    const currency = priceContainer?.dataset.currency;
    const formattedPrice = formatMoney(variant.price, currency);
    const comparePrice = priceContainer?.querySelector('[data-product-compare-price]');
    const currentPrice = priceContainer?.querySelector('[data-product-current-price]');
    if (currentPrice) currentPrice.textContent = formattedPrice;
    root.querySelectorAll('[data-sticky-price]').forEach((price) => { price.textContent = formattedPrice; });
    if (comparePrice) {
      const onSale = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      comparePrice.hidden = !onSale;
      comparePrice.textContent = onSale ? formatMoney(variant.compare_at_price, currency) : '';
    }

    const addLabel = root.dataset.labelAdd || '';
    const soldOutLabel = root.dataset.labelSoldOut || '';
    root.querySelectorAll('[data-product-submit]').forEach((button) => {
      const availableLabel = button.dataset.showVariantPrice === 'true' ? `${addLabel} · ${formattedPrice}` : addLabel;
      const label = variant.available ? availableLabel : soldOutLabel;
      button.dataset.defaultLabel = label;
      button.dataset.variantAvailable = String(Boolean(variant.available));
      button.disabled = !variant.available;
      button.textContent = label;
    });

    const status = root.querySelector('[data-product-status]');
    if (status) {
      status.textContent = variant.available ? '' : (root.dataset.statusSoldOut || soldOutLabel);
      status.classList.remove('mc-error');
    }
    const dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
    if (dynamicCheckout) {
      dynamicCheckout.hidden = !variant.available;
      dynamicCheckout.setAttribute('aria-hidden', String(!variant.available));
    }
    const gallery = root.querySelector('[data-product-gallery]');
    if (gallery && variant.featured_media_id != null) global.MoveCalmlyProductGallery?.select(gallery, variant.featured_media_id);
    return true;
  }

  function setControlsBusy(form, busy) {
    form.querySelectorAll('input,select').forEach((control) => {
      if (busy) {
        control.dataset.disabledBeforeProductRequest = String(control.disabled);
        control.disabled = true;
      } else if (control.dataset.disabledBeforeProductRequest !== undefined) {
        control.disabled = control.dataset.disabledBeforeProductRequest === 'true';
        delete control.dataset.disabledBeforeProductRequest;
      }
    });
  }

  function createPayload(form, FormDataConstructor = global.FormData) {
    return new FormDataConstructor(form);
  }

  function restoreLabels(root) {
    root.querySelectorAll('[data-product-submit]').forEach((button) => {
      button.textContent = button.dataset.defaultLabel || root.dataset.labelAdd || '';
      button.disabled = button.dataset.variantAvailable === 'false';
    });
  }

  global.MoveCalmlyVariantState = Object.freeze({ apply, createPayload, findVariant, formatMoney, parseVariants, restoreLabels, setControlsBusy });
})(window);
